import { URSSAF } from '@/utils/logos'

// TODO: gérer les traductions
export const embaucherGérerSalariés = {
	url: 'https://www.urssaf.fr/accueil/employeur/embaucher-gerer-salaries.html',
	title: 'Embaucher et gérer les salariés',
	description:
		'De l’embauche d’un salarié jusqu’à la fin de la relation de travail, l’Urssaf vous accompagne dans vos démarches et formalités à accomplir.',
	logo: URSSAF,
}
